// ============================================================
// WHO A CUT BROUGHT ON AND TOOK OFF, ON THIS SCREEN (plan design-gaps, Z3;
// the scenes page: the cast stands up with a ring, leavers fade, travellers
// pulse). A screen hears a cut's tokens BEFORE its stage document (the cut
// writes the stage last: hooks/useScenes), so by the time the cut is news its
// figures have already come and gone. This reads them back: the ones that
// first appeared, and the ones that went, in the moments before it.
//
// Pure. Zero React dependency. Milliseconds.
// ============================================================

/**
 * How far before a cut is heard its figures may have come or gone (the tokens, then the roster, then the stage).
 * Anything after it is the cut's too: a token may come in late, on its own subscription.
 */
export const CAST_LOOKBACK_MS = 5000;

/**
 * A cut's cast change, heard at `at`: the figures first seen and the ones gone since the lookback before it. `gone`
 * holds each leaver's last token, so it can fade where it stood.
 */
export function castChange<T>(
  firstSeen: ReadonlyMap<string, number>,
  gone: ReadonlyMap<string, { token: T; at: number }>,
  at: number,
): { entering: string[]; leavers: T[] } {
  const since = at - CAST_LOOKBACK_MS;
  const entering = [...firstSeen].filter(([, t]) => t >= since).map(([id]) => id);
  const leavers = [...gone.values()].filter((g) => g.at >= since).map((g) => g.token);
  return { entering, leavers };
}
